import React from "react";
export const VendorRatingReviewTableHead = ({
  reviewComments,
  service,
  ratingsDateTime,
  userName,
  action,
}) => {
  return (
    <React.Fragment>
      <tr>
        <th style={{ width: "15%" }} className="f12-700">
          {userName}
        </th>
        <th style={{ width: "15%" }} className="f12-700">
          {ratingsDateTime}
        </th>
        <th style={{ width: "40%" }} className="f12-700">
          {reviewComments}
        </th>
        <th style={{ width: "15%" }} className="f12-700">
          {service}
        </th>
        <th style={{ width: "15%" }} className="f12-700">
          {action}
        </th>
      </tr>
    </React.Fragment>
  );
};
